export default __webpack_public_path__ + "static/Hero_02a_BoardLetter-d65bb79ad612353d4a52de9526af3d33.jpg";